import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { useState } from "react";
import { useSelector } from "react-redux";
import { TEXT_TITLE, TEXT_SMALL, TEXT_NORMAL } from "../../style";
import { getWriteableDate } from "../../utils";
import { TASK_PRIORITIES } from "../../constants";
import UserSearch from "../common/UserSearch";

const EMPTY_USER_TASK_STATUSES = [];

const SORT_OPTIONS = [
    { label: "Newest first", value: "DESC" },
    { label: "Oldest first", value: "ASC" },
];

export default function TasksFiltersDrawer({ visible, onHide, setSearchQuery, showAssigneeFilter = false }) {
    const statuses = useSelector((state) => state.stateTemplateConfig?.global?.user_task_statuses ?? EMPTY_USER_TASK_STATUSES);

    const [status, setStatus] = useState(null);
    const [priority, setPriority] = useState(null);
    const [dateRange, setDateRange] = useState(null);
    const [deadlineRange, setDeadlineRange] = useState(null);
    const [sortOrder, setSortOrder] = useState("DESC");
    const [assignee, setAssignee] = useState(null);

    const clear = () => {
        setStatus(null);
        setPriority(null);
        setDateRange(null);
        setDeadlineRange(null);
        setSortOrder("DESC");
        setAssignee(null);
    };

    const apply = () => {
        setSearchQuery((prev) => {
            const next = { ...prev, offSet: 0, sort_order: sortOrder || "DESC" };
            delete next.status_id;
            delete next.priority;
            delete next.start_date;
            delete next.end_date;
            delete next.deadline_start;
            delete next.deadline_end;
            delete next.user_id;

            if (status?.id) next.status_id = status.id;
            if (priority != null) next.priority = priority.id;
            if (dateRange?.[0]) next.start_date = getWriteableDate({ date: dateRange[0], removeTime: true });
            if (dateRange?.[1]) next.end_date = getWriteableDate({ date: dateRange[1], removeTime: true });
            if (deadlineRange?.[0]) next.deadline_start = getWriteableDate({ date: deadlineRange[0], removeTime: true });
            if (deadlineRange?.[1]) next.deadline_end = getWriteableDate({ date: deadlineRange[1], removeTime: true });
            if (showAssigneeFilter && assignee?.id) next.user_id = assignee.id;

            return next;
        });
        onHide();
    };

    return (
        <Sidebar visible={visible} onHide={onHide}>
            <h2 className={`${TEXT_TITLE} mb-5`}>Filters</h2>

            <FloatLabel className="w-full mb-5">
                <Dropdown
                    className="w-full"
                    value={sortOrder}
                    options={SORT_OPTIONS}
                    optionLabel="label"
                    optionValue="value"
                    onChange={(e) => setSortOrder(e.value)}
                    pt={{ input: { className: TEXT_NORMAL }, item: { className: TEXT_NORMAL } }}
                />
                <label>Sort by created</label>
            </FloatLabel>

            <FloatLabel className="w-full mb-5">
                <Dropdown
                    className="w-full"
                    value={status}
                    options={statuses}
                    optionLabel="title"
                    showClear
                    onChange={(e) => setStatus(e.value)}
                    pt={{ input: { className: TEXT_NORMAL }, item: { className: TEXT_NORMAL } }}
                />
                <label>Status</label>
            </FloatLabel>

            <FloatLabel className="w-full mb-5">
                <Dropdown
                    className="w-full"
                    value={priority}
                    options={TASK_PRIORITIES}
                    optionLabel="label"
                    showClear
                    onChange={(e) => setPriority(e.value)}
                    pt={{ input: { className: TEXT_NORMAL }, item: { className: TEXT_NORMAL } }}
                />
                <label>Priority</label>
            </FloatLabel>

            <FloatLabel className="w-full mb-5">
                <Calendar
                    className="w-full"
                    value={dateRange}
                    onChange={(e) => setDateRange(e.value)}
                    selectionMode="range"
                    readOnlyInput
                    hideOnRangeSelection
                    dateFormat="dd/mm/yy"
                />
                <label>Created Date Range</label>
            </FloatLabel>

            <FloatLabel className="w-full mb-5">
                <Calendar
                    className="w-full"
                    value={deadlineRange}
                    onChange={(e) => setDeadlineRange(e.value)}
                    selectionMode="range"
                    readOnlyInput
                    hideOnRangeSelection
                    dateFormat="dd/mm/yy"
                />
                <label>Deadline Range</label>
            </FloatLabel>

            {showAssigneeFilter ? (
                <div className="w-full mb-5 mt-2">
                    <UserSearch
                        className="w-full"
                        value={assignee}
                        onChange={setAssignee}
                        floatLabel
                        label="Assignee"
                        inputId="tasks-filter-assignee"
                    />
                </div>
            ) : null}

            <div className="flex gap-2">
                <Button label="Clear" severity="danger" icon="pi pi-times" onClick={clear} pt={{ label: { className: TEXT_SMALL } }} />
                <Button label="Apply" severity="warning" icon="pi pi-check" onClick={apply} pt={{ label: { className: TEXT_SMALL } }} />
            </div>
        </Sidebar>
    );
}
